<div class="container">
    <p [ngClass]="businessLineBaseClassName+'-error-code'">
        4
        <img [alt]="'page-not-found-image'" [src]="imageUrl" class="error-code-image"/>
        4
    </p>
    <p class="title">{{ "pageNotFoundComponent.title" | translate}}</p>
    <p>{{ "pageNotFoundComponent.message" | translate}}</p>
    <button mat-button (click)="onBackToHomeClicked()">{{ "pageNotFoundComponent.backToHome" | translate}}</button>
</div>